import React from 'react'

const Copyright = () => {
    return (
        <div className="copyright-area copyright-style-one">
            <div className="container containerover">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-8 col-sm-12 col-12">
                        <div className="copyright-left">
                            <p className="copyright-text">© 2015-{new Date().getFullYear()} Autoview</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-4 col-sm-12 col-12">
                        <div className="copyright-right text-center text-md-end">
                            <ul className="ft-menu link-hover">
                                <li><a href="/disclosure/">Disclosures</a></li>
                                <li><a href="/our-policies/">Our Policies</a></li>
                                <li><a href="/terms-conditions/">Terms &amp; Conditions</a></li>
                                <li><a href="https://discord.gg/autoview" target="_blank" rel="noreferrer">Our Community</a></li>
                                <li><a href="https://use.autoview.com/" target="_blank" rel="noreferrer">Help Center</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Copyright;
